import React from 'react';
import * as yup from 'yup';

import { useFormik } from 'formik';
import { PartnerListBox } from '../../components/partnermng/PartnerListBox';
import PartnerStatusBox from '../../components/partnermng/PartnerStatusBox';

// 추가/엑셀 버튼은 PartnerListContainer의 breadcrumb action으로 이동(2026-10-22, chancemng 설계 적용).
const PartnerSearchContainer = ({
  searchList,
  searchTradeTyp,
  searchPartnerTyp,
  searchKeyword,
  searchWords,
}) => {
  const initialValues = {
    searchTradeTyp: Array.isArray(searchTradeTyp) ? searchTradeTyp : [],
    searchPartnerTyp: searchPartnerTyp,
    searchKeyword: searchKeyword,
    searchWords: searchWords,
  };

  const validationSchema = yup.object({
    searchTradeTyp: yup.array().of(yup.string()).nullable(),
    searchPartnerTyp: yup.string().nullable(),
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      searchList(values);
      setSubmitting(false);
    },
  });

  // PartnerStatusBox에서 토글된 값을 받으면 해당 필드를 업데이트
  const handleFilters = (key, next) => {
    formik.setFieldValue(key, next);
    // 즉시 검색하고 싶으면 여기서 formik.submitForm() 호출
  };

  // 검색 카드 "초기화" - redux 필터/reset 액션이 없고 로컬 state라, 초기값으로 직접
  // 되돌리고 다시 조회한다(2026-10-22, taxIssuedmng과 동일한 패턴).
  const handleReset = () => {
    const resetValues = {
      searchTradeTyp: ['매출처', '매입처', '제조사'],
      searchPartnerTyp: '',
      searchKeyword: 'partnerNm',
      searchWords: '',
    };
    formik.setValues(resetValues);
    searchList(resetValues);
  };

  return (
    <>
      {/* 2) PartnerListBox 렌더링 */}
      <PartnerListBox formik={formik} onReset={handleReset} />
      {/* 1) PartnerStatusBox 렌더링: filters + onFilters */}
      <PartnerStatusBox
        filters={formik.values}
        onFilters={handleFilters}
      />
    </>
  );
};

export default PartnerSearchContainer;
